<template>
  <div v-if="open" id="location-dialog">
    <transition name="fade" appear>
      <div class="modal-overlay" @click.prevent="$emit('cancel')"></div>
    </transition>
    <transition name="pop" appear>
      <div class="modal location-border" role="dialog"  v-if="open">
        <div class="location-container">
          <div class="all-div">
            <img
              class="location-svg"
              src="@/assets/svg/location_permission.svg"
            />
            <div class="location-thanks">
              <p class="location-heading">Location Share</p>

              <div class="location-des-main" >
                <p class="location-detail">
                  We'd like to share {{pet_name || "this pet"}}’s current location with the
                  owner.

                </p>
                <br />
                <p class="location-detail">
                  On the next screen, please click
                  <span class="fw-700-color-blue">‘ALLOW’</span> which will share
                  the current location {{pet_name  ? "of "+pet_name : ""}} with the owner.
                </p>
                <br />
                <p class="location-thanks">Thank you!</p>
              </div>
              <!-- <div v-else-if="acceptance_status == 'denied'">
                <p class="location-detail">You have denied your location. The pet owner can not see your location. You can rescan the tag to Accept location permissions or enable it in your phone settings. </p>
              </div> -->

            </div>
            <div class="buttons">
              <button
                @click.prevent="$emit('continue')"
                class="btn btn-common primary btn-text"
              >
                Continue
              </button>
              <button
                @click.prevent="$emit('cancel')"
                class="btn btn-common bg-yellow btn-text"
              >
                Cancel
              </button>
            </div>
            <!-- <div else>
              <button
                @click.prevent="$emit('toPet')"
                class="btn btn-common primary btn-text"
              >
                Ok
              </button>
            </div> -->
          </div>
        </div>
      </div>

    </transition>
  </div>
</template>

<script>
export default {
  name: "LocationDialog",
  props: ["open","pet_name", "acceptance_status"],
};
</script>

<style scoped>
#location-dialog {
  min-height: 100%;
  margin: 0;
  display: grid;
  place-items: center;
  font-size: 1.4rem;
}
/*.button {
  border: none;
  color: #fff;
  background: #42b983;
  appearance: none;
  font: inherit;
  font-size: 1.8rem;
  padding: 0.5em 1em;
  border-radius: 0.3em;
  cursor: pointer;
}*/

.modal{
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 999;
  width: fit-content;
  height: fit-content;
  transform: none;
  text-align: center;
}
.location-container {
  /*max-width: 22em;*/
  /*padding: 2rem;*/
  border-radius: 1rem;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  background: #fff;
}
.modal h1 {
  margin: 0 0 1rem;
}

.modal-overlay {
  content: "";
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: #2c3e50;
  opacity: 0.6;
  cursor: pointer;
}

/* ---------------------------------- */
/*.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-50%);
}*/
.location-border {
  margin: auto;
  padding-left: 24px;
  padding-right: 24px;
}
.location-container{
  padding-top: 23px;
  padding-bottom: 29px;
}
.location-svg {
  max-width: 164px;
  margin: auto;
  margin-bottom: 4px;
}
.all-div {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.location-thanks {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.location-heading {
  margin: auto;
  color: #1a1f36;
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
  text-align: center;
  font-family: Altis;
}
.location-des-main {
  /*width: 269px;*/
  /*height: 167px;*/
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto 28px;
}
.location-detail {
  color: #434345;
  font-size: 14px;
  line-height: 19.6px;
  font-weight: 400;
  letter-spacing: 0.2px;
  text-align: center;
  font-family: Altis;
}
.fw-700-color-blue {
  font-weight: 700;
  color: #6266f0;
}
.location-thanks {
  font-size: 18px;
  font-weight: 700;
  line-height: 25.2px;
  letter-spacing: 0.2px;
  text-align: center;
  font-family: Altis;
}
.btn-common {
  margin: 0;
  padding: 12px 19px;
}
.bg-yellow {
  background-color: #f5c042;
}
.btn-text {
  font-size: 18px;
  line-height: 23.26px;
  font-weight: 700;
  text-align: Center;
}
.buttons {
  display: flex;
  justify-content: space-between;
  gap: 17px;
  padding: 0 17px;
}
</style>
